<script lang="ts">
    import { onDestroy, onMount } from "svelte"

    interface Props {
        rightDefaultMargin?: boolean
        slider: import("svelte").Snippet
    }

    let { slider, rightDefaultMargin = false }: Props = $props()
    let sliderWrapper: HTMLElement | null = null
    function scrollContent(offset: number) {
        const slider = sliderWrapper.querySelector(" .simplebar-content-wrapper")
        if (slider) slider.scrollBy({ left: offset, behavior: "smooth" })
    }

    let list: HTMLDivElement
    let scrollable: HTMLDivElement

    let isDown = false
    let startX = 0
    let scrollLeft = 0
    let hasDragged = false
    const dragThreshold = 5 // Pixel, um einen echten Drag von einem Klick zu unterscheiden

    const onMouseDown = (e: MouseEvent) => {
        isDown = true
        hasDragged = false
        if (scrollable) {
            startX = e.pageX - scrollable.offsetLeft
            scrollLeft = scrollable.scrollLeft
        }
        window.addEventListener("mousemove", onMouseMove)
        window.addEventListener("mouseup", onMouseUp)
    }

    const onMouseMove = (e: MouseEvent) => {
        if (!isDown || !scrollable) return
        const x = e.pageX - scrollable.offsetLeft
        const diff = x - startX
        if (Math.abs(diff) > dragThreshold) {
            hasDragged = true
        }
        e.preventDefault()
        const walk = diff
        scrollable.scrollLeft = scrollLeft - walk
    }

    const onMouseUp = () => {
        isDown = false
        window.removeEventListener("mousemove", onMouseMove)
        window.removeEventListener("mouseup", onMouseUp)
    }
    const onClick = (e: MouseEvent) => {
        if (hasDragged) {
            e.preventDefault()
            e.stopPropagation()
            // Flag zurücksetzen
            hasDragged = false
        }
    }

    let scrollableIsScrollable = $state(false)
    onMount(() => {
        setTimeout(() => {
            scrollable = list.querySelector<HTMLDivElement>(".simplebar-content-wrapper")
            scrollable.style.overflowY = "hidden"

            if (scrollable) {
                scrollable.addEventListener("mousedown", onMouseDown)
                scrollable.addEventListener("click", onClick, true)
                window.addEventListener("blur", onMouseUp)
            }
        }, 100)
        let int = setInterval(() => {
            if (scrollable) {
                scrollableIsScrollable = scrollable.scrollWidth > scrollable.clientWidth
            }
        }, 1000)
        return () => clearInterval(int)
    })

    onDestroy(() => {
        if (scrollable) {
            scrollable.removeEventListener("mousedown", onMouseDown)
        }
        window.removeEventListener("mousemove", onMouseMove)
        window.removeEventListener("mouseup", onMouseUp)
    })
</script>

<div
    class="slider-wrapper"
    bind:this={sliderWrapper}
    class:rightDefaultMargin
    class:scrollableIsNotScrollable={!scrollableIsScrollable}
>
    <div class="slider" class:rightDefaultMargin data-simplebar bind:this={list}>
        <div class="padding-slider">
            {@render slider()}
        </div>
    </div>
    {#if scrollableIsScrollable}
        <div class="scroll-buttons">
            <button class="scroll-button left" onclick={() => scrollContent(-370)}>
                <img src="/media/leftChev.svg" alt="arrow-left" />
            </button>
            <button class="scroll-button right" onclick={() => scrollContent(370)}>
                <img src="/media/rightChev.svg" alt="arrow-right" />
            </button>
        </div>
    {/if}
</div>

<style lang="less" global>
    @import "../../../css/variables.less";
    :root {
        --width-scroll-buttons: calc(2.4rem * 2 + 1.2rem * 2);
    }
    .scroll-button {
        border-radius: 100px;
        border: 1px solid var(--dark-100);
        display: flex;
        width: 2.4rem;
        height: 2.4rem;
        padding: 10px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }
    .slider-wrapper {
        position: relative;
        width: 100%;
        z-index: 6;

        .scroll-buttons {
            display: flex;
            gap: 1.2rem;
            position: absolute;
            background-color: var(--bg-100);
            z-index: 9999;
            bottom: 0;
            left: max(calc((100vw - var(--extended-max-width)) / 2), var(--default-padding));
            justify-content: flex-start;
            width: var(--width-scroll-buttons);
            @media @max-mobile {
                right: 1.2rem;
            }
        }

        .slider {
            width: 100%;
            height: 100%;
            position: relative;
            padding: 1.2rem 0px;
            cursor: pointer !important;
            .padding-slider {
                padding-bottom: 1.2rem;

                @media @max-mobile {
                    padding-bottom: 2.4rem;
                }
            }
            &.rightDefaultMargin {
                padding-left: var(--default-padding);
                @media @desktop_large {
                    padding-left: max(calc((100vw - var(--extended-max-width)) / 2), var(--default-padding));
                }
            }
            @media @max-mobile {
                padding: 0px;
            }
        }
        .simplebar-wrapper {
            padding-bottom: 1.2rem;
        }

        .simplebar-track {
            background: var(--dark-20);
            height: 3px !important;
            overflow: visible;
            width: min(
                calc(var(--extended-max-width) - var(--width-scroll-buttons)),
                calc(100vw - var(--width-scroll-buttons) - 2 * var(--default-padding))
            );
            max-width: min(
                calc(var(--extended-max-width) - var(--width-scroll-buttons)),
                calc(100vw - var(--width-scroll-buttons) - 2 * var(--default-padding))
            );
            right: max(var(--default-padding), calc((100vw - var(--extended-max-width)) / 2));
            left: unset !important;
            margin-bottom: 1.2rem;
        }
        &.scrollableIsNotScrollable {
            .simplebar-track {
                display: none;
            }
        }
        &.rightDefaultMargin {
            .simplebar-track {
                margin-left: calc((100vw - var(--extended-max-width)) / 2);
                @media @max-mobile {
                    margin-left: var(--default-padding);
                }
            }
        }
        .simplebar-scrollbar {
            transition-duration: 0ms !important;
            cursor: pointer;
            &::before {
                background: var(--brand-100);
                opacity: 1;
                border-radius: 0;
                display: flex;
                margin-top: -2px;
                height: 3px;
                left: 0px;
                transition-delay: 0s;
            }
        }
    }
</style>
